import i18n from '@/i18n';
import { payWithTinaba, getTinabaPayUrl } from '@/common/TinabaPay'
import { Vue } from "vue-property-decorator";
import { mapState, mapActions, mapMutations } from 'vuex'

const POLLING_TIMEOUT = 3000

export function checkEmpty (data: any) : any {
  return data ? data : ''
}

const PaymentBaseProps = Vue.extend({
  computed: {
    ...mapState('global', [
      'paypalData',
      'checkout',
      'cart'
    ])
  },
  methods: {
    ...mapActions('global', [
      'startAliPayCheckout', 
      'fetchPaypalDetails', 
      'initCheckout',
    ]),
  }
})

export default class PaymentBase extends PaymentBaseProps {
  isPolling = false
  lastPoll: any = null

  get payment () {
    return this.checkout
  }

  get paymentDetail () {
    if (!this.payment) return {}
    return {
      refId : this.payment.productCodeId,
      desc : this.payment.description,
      import: this.payment.amount ? i18n.n(this.payment.amount / 100, 'currency') : null,
      // validity : moment(this.payment.expireDate).locale(getDayJSLocale(i18n.locale)).format(`D MMMM YYYY HH:mm${i18n.locale == 'it'? '':' Z'}`)
    }
  }

  get paymentUrl () {
    if (!this.tinanaPayPayload) return ''
    return getTinabaPayUrl(this.tinanaPayPayload).viaBrowserDeeplinkUrl
  }

  get tinanaPayPayload () {
    if (!this.payment) return null
    return {
      id: this.payment.id,
      paymentCode: this.payment.qrCodeValue,
      amount: this.payment.amount
    }
  }

  async createCheckoutAndProcess (next = () => {}) {
    try {
      /*
      if (this.checkout && this.checkout.description.includes(this.cart.id)) {
        return next()
      }
      */
      await this.initCheckout() 
      next()
    } catch (error) {
      console.log(error)
      alert('Something went wrong')
    }
  }

  handleCardPay () {
    // this.$router.push({ name: 'CardPay', params: { id: `${this.payment.id}` } })
  }

  setGlobalLoading () {
    return this.$store.commit('global/toggleGlobalLoading', true, { root: true })
  }

  unsetGlobalLoading () {
    return this.$store.commit('global/toggleGlobalLoading', false, { root: true })
  }

  triggerPoll () {
    if (!this.payment) return Promise.resolve()
    return this.$store.dispatch('global/triggerCheckoutPoll')
  }

  _executePoll () {
    this.triggerPoll().then(() => {
      if (!this.isPolling) return null
      this.lastPoll = setTimeout(() => this._executePoll(), POLLING_TIMEOUT)
    })
  }

  stopPolling () {
    if (this.lastPoll) {
      clearTimeout(this.lastPoll)
    }
    
    this.lastPoll  = null
    this.isPolling = false
  }

  initPolling () {
    if (this.isPolling) return this.stopPolling
    this.isPolling = true
    this._executePoll()
    return this.stopPolling
  }
  
  beforeDestroy () {
    this.stopPolling()
  }
}